import { render } from "./ChoixPortailFournisseur.vue?vue&type=template&id=1f49e3f6&ts=true"
import script from "./ChoixPortailFournisseur.vue?vue&type=script&lang=ts"
export * from "./ChoixPortailFournisseur.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__